<template>
    <v-container fluid>
        <v-card>
            <v-card-title>已安排發送訊息列表</v-card-title>
            <v-spacer></v-spacer>
            <v-data-table
                :headers="listHeaders"
                :items="sms_logs"
                :page.sync="pagination.current"
                :items-per-page="pagination.itemsPerPage"
                :hide-default-footer="true"
                disable-pagination
            >
                <template v-slot:top>
                    <!-- For Header Usage-->
                    <v-dialog v-model="detailDialog" max-width="800px">
                        <v-card>
                            <v-card-title>簡訊發送內容</v-card-title>

                            <v-card-subtitle>訊息發送人：{{selected_sms_log.user_name}}<br/>訊息建立日期：{{selected_sms_log.created_at}}</v-card-subtitle>
                            <v-divider></v-divider>
                            <v-row>
                                <v-col>
                                    <v-card-subtitle><b>簡訊內容</b></v-card-subtitle>
                                    <v-card-text v-html="DisplayedMessage"></v-card-text>
                                </v-col>
                                <v-col>
                                    <v-card-subtitle><b>發送對象{{ (selected_sms_log.holders.length > 0) ? "：共" + selected_sms_log.holders.length + "筆" : "" }}</b></v-card-subtitle>
                                    <v-list style="max-height: 400px" class="overflow-y-auto">
                                        <div v-for="(field, index) in selected_sms_log.holders" :key="index">
                                            <v-list-item two-line>
                                                <v-list-item-content>
                                                    <v-list-item-title>{{field.holder_name}}</v-list-item-title>
                                                    <v-list-item-subtitle>{{field.phone}}</v-list-item-subtitle>
                                                    <v-list-item-subtitle>{{field.push_status}}{{(field.push_at!="") ? "(" + field.push_at + ")": "" }}</v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </div>
                                    </v-list>
                                </v-col>
                            </v-row>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" @click="closeDetailDialog">關閉</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </template>
                <template v-slot:[`item.sms_content`]="{ item }"> 
                    <span v-html="item.sms_content"></span> <!--把簡訊欄位用HTML格式顯示-->
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <v-icon large class="mr-2" text @click="viewSMSNotices(item)">mdi-magnify</v-icon>
                </template>
            </v-data-table>
            <v-pagination v-model="pagination.current" :length="pagination.total" @input="onPageChange"></v-pagination>
        </v-card>
    </v-container>
</template>

<script>
import HolderNotifyService from '../../services/HolderNotifyService'
export default {
    data(){
        return {
            listHeaders:[
                {text: '訊息建立日期', value:'created_at', width: '140px'},
                {text: '訊息內容', align:'start', sortable:false, value:'sms_content'},
                {text: '訊息發送人', value:'user_name', width: '120px'},
                {text: '查看內容', value:'actions', sortable:false, width: '80px'}
            ],
            sms_logs:[],
            selected_sms_log:{
                created_at:'',
                user_name:'',
                message:'',
                holders:[]
            },
            pagination: {
                current: 1,
                total: 0,
                itemsPerPage: 10
            },
            detailDialog: false
        }
    },
    mounted(){
        this.searchSmsLogs();
    },
    setup() {
        
    },
    computed:{
        DisplayedMessage(){
            return this.selected_sms_log.message.replace(/(?:\r\n|\r|\n)/g,'<br/>')
        }
    },
    methods:{
        viewSMSNotices(sms_log){
            console.log(sms_log)
            this.selected_sms_log.created_at = sms_log.created_at
            this.selected_sms_log.user_name = sms_log.user_name
            this.selected_sms_log.message = sms_log.sms_content
            HolderNotifyService.findBySmsLogId(sms_log).then((response) =>{
                if (response.result === true) {
                    console.log(response.list)
                    this.selected_sms_log.holders = response.list.map(this.mapHolderData)
                    this.detailDialog = true
                } else {
                    this.selected_sms_log.holders = []
                }
            })
        },
        mapHolderData(item){
            var push_status =''
            if (item.push_status == 'new') push_status ='等待發送'
            if (item.push_status == 'sent') push_status ='已發送'
            if (item.push_status == 'error') push_status ='發送失敗'
            return {
                id: item.id,
                holder_name: item.holder_name,
                phone: item.phone,
                push_status: push_status,
                push_at: item.push_at
            }
        },
        searchSmsLogs(){
            HolderNotifyService.findLogByCondition('',this.pagination.current,this.pagination.itemsPerPage)
                .then((response) => {
                    if (response.result === true) {
                        this.sms_logs = response.list.map(this.mapData)
                        this.pagination.total = response.last_page
                    } else {
                        this.sms_logs = []
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        mapData(item){
            return {
                id: item.id,
                sms_content: item.sms_content.replace(/(?:\r\n|\r|\n)/g,'<br/>'),
                created_at: item.created_at,
                user_name: item.user_name,
            }
        },
        onPageChange(){
            this.searchSmsLogs();
        },

        closeDetailDialog(){
            this.selected_sms_log.message ='';
            this.selected_sms_log.created_at= '';
            this.selected_sms_log.user_name='';
            this.selected_sms_log.holders =[];
            this.detailDialog = false;
        }
    }
}
</script>
